export enum PaymentPlanTypeEnum {
    DAILY = 'daily',
    WEEKLY = 'weekly',
    MONTHLY = 'monthly',
    YEARLY = 'yearly',
    LIFETIME = 'lifetime'
}

export const PaymentPlanTypeLabels: Record<PaymentPlanTypeEnum, string> = {
    [PaymentPlanTypeEnum.DAILY]: "Diário",
    [PaymentPlanTypeEnum.WEEKLY]: "Semanal",
    [PaymentPlanTypeEnum.MONTHLY]: "Mensal",
    [PaymentPlanTypeEnum.YEARLY]: "Anual",
    [PaymentPlanTypeEnum.LIFETIME]: "Vitalício"
};